module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 442
// module chunks = 0